import React, { useState } from "react";
import { useEffect } from "react";
import Loader from "../Loader/Loader";
import "./TxStatus.css";

function TxStatus({ _status }) {
  const [status, setStatus] = useState("none");

  useEffect(() => {
    setStatus(_status);
  }, [_status]);

  return (
    <div
      className="tx-status"
      style={{ display: status === "none" ? "none" : "flex" }}
    >
      <p>TX status:</p>
      <p>{status}</p>
      <Loader />
    </div>
  );
}

export default TxStatus;
